export default __webpack_public_path__ + "static/media/download.2c1f75fe.svg";